import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { langData } from "./langData";

Vue.config.productionTip = false;
Vue.use(VueI18n);
const hacoStorage: Storage = localStorage;
const language =
  hacoStorage.getItem("language") && hacoStorage.getItem("language") === "ja"
    ? "ja"
    : "en";
const i18n: VueI18n = new VueI18n({
  locale: language,
  messages: langData
});

Vue.prototype.$certification = false;
Vue.prototype.$debugServer =
  window.location.hostname === "localhost" && window.location.port === ""
    ? "https://sandbox-hp.hacoplay.page"
    : process.env.NODE_ENV === "development"
    ? "https://localhost:8081"
    : "";
// https://localhost:8081
Vue.prototype.$currentPage = "currentPage";

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
